"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeToTldMap = exports.getDomain = exports.Tld = exports.Domains = void 0;
const brand_1 = require("../brand");
const country_code_1 = require("../country-code");
const platform_1 = require("../platform");
var Domains;
(function (Domains) {
    Domains["BK_AQ"] = "www.burgerking.io";
    Domains["BK_AT"] = "www.burgerking.at";
    Domains["BK_CA"] = "www.burgerking.ca";
    Domains["BK_CH"] = "www.burger-king.ch";
    Domains["BK_CZ"] = "www.burgerking.cz";
    Domains["BK_DE"] = "www.burgerking.de";
    Domains["BK_ES"] = "www.burgerking.es";
    Domains["BK_GB"] = "www.burgerking.co.uk";
    Domains["BK_NL"] = "www.burgerking.nl";
    Domains["BK_NZ"] = "www.burgerking.co.nz";
    Domains["BK_PL"] = "www.burgerking.pl";
    Domains["BK_PT"] = "www.burgerking.pt";
    Domains["BK_RO"] = "www.burgerking.ro";
    Domains["BK"] = "www.bk.com";
    Domains["BK_ZA"] = "www.burgerking.co.za";
    Domains["LTW"] = "";
    Domains["PLK_AQ"] = "www.popeyeschicken.io";
    Domains["PLK_CA"] = "www.popeyeschicken.ca";
    Domains["PLK_CH"] = "www.popeyeschicken.ch";
    Domains["PLK_CZ"] = "www.popeyeschicken.cz";
    Domains["PLK_ES"] = "www.popeyeschicken.es";
    Domains["PLK_FR"] = "www.popeyeschicken.fr";
    Domains["PLK_KR"] = "www.popeyeschicken.co.kr";
    Domains["PLK_NZ"] = "www.popeyeschicken.co.nz";
    Domains["PLK_PL"] = "www.popeyeschicken.pl";
    Domains["PLK_PT"] = "www.popeyeschicken.pt";
    Domains["PLK_SG"] = "www.popeyeschicken.com.sg";
    Domains["PLK_TH"] = "www.popeyeschicken.th";
    Domains["PLK_TW"] = "www.popeyeschicken.tw";
    Domains["PLK"] = "www.popeyes.com";
    Domains["TH_AQ"] = "www.timhortons.io";
    Domains["TH_CA"] = "www.timhortons.ca";
    Domains["TH_ES"] = "www.timhortons.es";
    Domains["TH_ID"] = "www.timhortons.id";
    Domains["TH_JP"] = "www.timhortons.jp";
    Domains["TH_KR"] = "www.timhortons.co.kr";
    Domains["TH_MY"] = "www.timhortons.my";
    Domains["TH_TW"] = "www.timhortons.tw";
    Domains["TH_US"] = "www.timhortons.com";
    Domains["FHS_AQ"] = "www.firehousesubs.io";
    Domains["FHS_CA"] = "www.firehousesubs.ca";
    Domains["FHS_CH"] = "www.firehousesubs.ch";
    Domains["FHS_US"] = "www.firehousesubs.com";
})(Domains || (exports.Domains = Domains = {}));
var Tld;
(function (Tld) {
    Tld["AQ"] = "io";
    Tld["AT"] = "at";
    Tld["CA"] = "ca";
    Tld["CH"] = "ch";
    Tld["CZ"] = "cz";
    Tld["DE"] = "de";
    Tld["ES"] = "es";
    Tld["FR"] = "fr";
    Tld["GB"] = "co.uk";
    Tld["ID"] = "id";
    Tld["JP"] = "jp";
    Tld["KR"] = "co.kr";
    Tld["MY"] = "my";
    Tld["NL"] = "nl";
    Tld["NZ"] = "co.nz";
    Tld["PL"] = "pl";
    Tld["PT"] = "pt";
    Tld["RO"] = "ro";
    Tld["SG"] = "com.sg";
    Tld["TH"] = "th";
    Tld["TW"] = "tw";
    Tld["US"] = "com";
    Tld["ZA"] = "co.za";
})(Tld || (exports.Tld = Tld = {}));
/**
 * Return the production domain for the configured brand
 */
const getDomain = (brand, locale, platform) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    switch (brand) {
        case brand_1.Brand.BK:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.BK_AQ;
                case country_code_1.IsoCountryCode2Char.AT:
                    return Domains.BK_AT;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.BK_CA;
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.BK_CH;
                case country_code_1.IsoCountryCode2Char.CZ:
                    return Domains.BK_CZ;
                case country_code_1.IsoCountryCode2Char.DE:
                    return Domains.BK_DE;
                case country_code_1.IsoCountryCode2Char.ES:
                    return Domains.BK_ES;
                case country_code_1.IsoCountryCode2Char.GB:
                    return Domains.BK_GB;
                case country_code_1.IsoCountryCode2Char.NL:
                    return Domains.BK_NL;
                case country_code_1.IsoCountryCode2Char.NZ:
                    return Domains.BK_NZ;
                case country_code_1.IsoCountryCode2Char.PL:
                    return Domains.BK_PL;
                case country_code_1.IsoCountryCode2Char.PT:
                    return Domains.BK_PT;
                case country_code_1.IsoCountryCode2Char.RO:
                    return Domains.BK_RO;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.BK;
                case country_code_1.IsoCountryCode2Char.ZA:
                    return Domains.BK_ZA;
                default:
                    return Domains.BK;
            }
        case brand_1.Brand.LTW:
            return Domains.LTW;
        case brand_1.Brand.PLK:
            switch (locale.region) {
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.PLK_AQ;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.PLK_CA;
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.PLK_CH;
                case country_code_1.IsoCountryCode2Char.CZ:
                    return Domains.PLK_CZ;
                case country_code_1.IsoCountryCode2Char.ES:
                    return Domains.PLK_ES;
                case country_code_1.IsoCountryCode2Char.FR:
                    return Domains.PLK_FR;
                case country_code_1.IsoCountryCode2Char.KR:
                    return Domains.PLK_KR;
                case country_code_1.IsoCountryCode2Char.NZ:
                    return Domains.PLK_NZ;
                case country_code_1.IsoCountryCode2Char.PL:
                    return Domains.PLK_PL;
                case country_code_1.IsoCountryCode2Char.PT:
                    return Domains.PLK_PT;
                case country_code_1.IsoCountryCode2Char.SG:
                    return Domains.PLK_SG;
                case country_code_1.IsoCountryCode2Char.TH:
                    return Domains.PLK_TH;
                case country_code_1.IsoCountryCode2Char.TW:
                    return Domains.PLK_TW;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.PLK;
                default:
                    return Domains.PLK;
            }
        case brand_1.Brand.TH:
            if (platform === platform_1.Platform.app) {
                return Domains.TH_CA;
            }
            switch (locale.region) {
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.TH_AQ;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.TH_CA;
                case country_code_1.IsoCountryCode2Char.ES:
                    return Domains.TH_ES;
                case country_code_1.IsoCountryCode2Char.ID:
                    return Domains.TH_ID;
                case country_code_1.IsoCountryCode2Char.JP:
                    return Domains.TH_JP;
                case country_code_1.IsoCountryCode2Char.KR:
                    return Domains.TH_KR;
                case country_code_1.IsoCountryCode2Char.MY:
                    return Domains.TH_MY;
                case country_code_1.IsoCountryCode2Char.TW:
                    return Domains.TH_TW;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.TH_US;
                default:
                    return Domains.TH_CA;
            }
        case brand_1.Brand.FHS:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.FHS_AQ;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.FHS_CA;
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.FHS_CH;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.FHS_US;
                default:
                    return Domains.FHS_US;
            }
        default:
            return Domains.PLK;
    }
};
exports.getDomain = getDomain;
exports.localeToTldMap = new Map([
    [country_code_1.IsoCountryCode2Char.AQ, Tld.AQ],
    [country_code_1.IsoCountryCode2Char.AT, Tld.AT],
    [country_code_1.IsoCountryCode2Char.CA, Tld.CA],
    [country_code_1.IsoCountryCode2Char.CH, Tld.CH],
    [country_code_1.IsoCountryCode2Char.CZ, Tld.CZ],
    [country_code_1.IsoCountryCode2Char.DE, Tld.DE],
    [country_code_1.IsoCountryCode2Char.ES, Tld.ES],
    [country_code_1.IsoCountryCode2Char.FR, Tld.FR],
    [country_code_1.IsoCountryCode2Char.GB, Tld.GB],
    [country_code_1.IsoCountryCode2Char.ID, Tld.ID],
    [country_code_1.IsoCountryCode2Char.JP, Tld.JP],
    [country_code_1.IsoCountryCode2Char.KR, Tld.KR],
    [country_code_1.IsoCountryCode2Char.MY, Tld.MY],
    [country_code_1.IsoCountryCode2Char.NL, Tld.NL],
    [country_code_1.IsoCountryCode2Char.NZ, Tld.NZ],
    [country_code_1.IsoCountryCode2Char.PL, Tld.PL],
    [country_code_1.IsoCountryCode2Char.PT, Tld.PT],
    [country_code_1.IsoCountryCode2Char.RO, Tld.RO],
    [country_code_1.IsoCountryCode2Char.SG, Tld.SG],
    [country_code_1.IsoCountryCode2Char.TH, Tld.TH],
    [country_code_1.IsoCountryCode2Char.TW, Tld.TW],
    [country_code_1.IsoCountryCode2Char.US, Tld.US],
    [country_code_1.IsoCountryCode2Char.ZA, Tld.ZA],
]);
//# sourceMappingURL=domains.js.map